import {
  CalendarOutlined,
  HomeOutlined,
  PhoneOutlined,
  VideoCameraOutlined,
} from '@ant-design/icons';
import { Button } from 'antd';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import DoctorCard from 'commons/components/doctorcard/DoctorCard';
import {
  isMeetingSoon,
  isNextMeetingIsScheduled,
} from 'commons/libs/meeting_utils';
import { Meeting, MEETING_TYPES, SOON_DIFF } from 'commons/types/meetingsTypes';

import { User } from 'stores/user/userTypes';

interface MeetingCardProps {
  user: User | undefined;
  meeting: Meeting | undefined;
}

export default function MeetingCard({ user, meeting }: MeetingCardProps) {
  if (meeting === undefined || !isNextMeetingIsScheduled(meeting)) {
    return null;
  }

  return (
    <div className='flex flex-col items-center w-full bg-primary-light text-secondary px-6 pb-6 rounded-2xl text-center text-sm'>
      <div className='flex flex-row justify-between items-center w-full text-xs'>
        <p className='flex flex-row m-0 mt-1 text-content-minor'>
          Mon prochain rendez-vous
        </p>
        <Link to='move-schedule'>
          <Button
            type='link'
            className='!inline-flex !items-center !justify-center !h-6 !m-0 !p-0 !mt-2 !text-primary !text-xs'
          >
            déplacer <CalendarOutlined />
          </Button>
        </Link>
      </div>
      <DoctorCard
        rdvType={meeting.type}
        doctorName={meeting.metadata.employee}
        avatar={meeting.doctor?.avatar}
        startDate={meeting.start_date}
      />
      <div>
        {meeting.type === MEETING_TYPES.RDV_1 && <Phone user={user} />}
        {meeting.type === MEETING_TYPES.RDV_2 && <OnSite meeting={meeting} />}
        {meeting.type === MEETING_TYPES.RDV_3 && <Visio meeting={meeting} />}
      </div>
    </div>
  );
}

function Phone({ user }: { user: User | undefined }) {
  return (
    <div className='font-semibold text-base'>
      <p className='m-0'>
        <PhoneOutlined className='text-2xl mr-2' /> par télephone
      </p>
      <p className='text-xs text-content-minor font-light mt-1'>
        Un de nos experts vous contactera au {user?.phone}
      </p>
    </div>
  );
}
function OnSite({ meeting }: { meeting: Meeting }) {
  return (
    <div className='font-semibold text-base'>
      <p className='m-0'>
        <HomeOutlined className='text-2xl mr-2' /> en cabinet médical
      </p>
      <p className='text-xs text-content-minor font-light mt-1'>
        {meeting.metadata.address}
      </p>
    </div>
  );
}

function Visio({ meeting }: { meeting: Meeting }) {
  const isSoon = useMemo(() => isMeetingSoon(meeting), [meeting]);

  return (
    <div>
      {isSoon ? (
        <div className='font-semibold text-base'>
          <Link to={meeting.uri}>
            <Button
              type='primary'
              size='large'
            >
              J&apos;accède à la vidéoconférence
            </Button>
          </Link>
        </div>
      ) : (
        <div className='font-semibold text-base'>
          <p className='m-0'>
            <VideoCameraOutlined className='text-2xl mr-2' /> par
            vidéoconference
          </p>
          <p className='text-xs text-content-minor font-light mt-1'>
            Le lien de la vidéo sera disponible {SOON_DIFF} minutes avant le rdv
          </p>
        </div>
      )}
    </div>
  );
}
